import { Injectable } from '@angular/core';
import { Router, UrlSegment } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageRouteService {
  constructor(
    private router: Router,
    private translate: TranslateService
  ) {}

  getCurrentLang(): string {
    // Try to get from route, fallback to translate service
    const urlSegments = this.router.url.split('/').filter(Boolean);
    if (urlSegments.length > 0 && ['de','en','fr','nl','lb'].includes(urlSegments[1])) {
      return urlSegments[1];
    }
    return this.translate.currentLang || 'de';
  }

  /**
   * Switches the language in the current route, preserving all other segments and query params.
   * @param lang The new language code
   */
  switchLanguageInCurrentRoute(lang: string) {
    const urlTree = this.router.parseUrl(this.router.url);
    const primary = urlTree.root.children['primary'];
    const segments = primary && primary.segments ? primary.segments.map(s => s.path) : [];
    if (segments.length > 0 && ['de','en','fr','nl','lb'].includes(segments[1])) {
      segments[1] = lang;
      primary.segments = segments.map(s => new UrlSegment(s, {}));
      this.router.navigateByUrl(urlTree);
    } else {
      segments.splice(1, 0, lang)
      window.location.replace(`/${segments[0]}/${lang}/${segments[2]}${window.location.search}`)
    }
  }

  /**
   * Navigates to a section (and optional sub-paths) using lang and token from the current route.
   * @param route ActivatedRoute (from the component)
   * @param section The main section (e.g. 'tickets', 'groups', etc.)
   * @param subPaths Optional array of sub-paths after the section
   * @param extras Navigation extras (e.g. queryParams)
   */
  navigateToSectionWithLangAndToken(route: any, section: string, subPaths: any[] = [], extras: any = {}) {
    // Traverse up to find lang and token
    let snapshot = route.snapshot;
    let lang = snapshot.paramMap && snapshot.paramMap.get('lang');
    let token = snapshot.paramMap && snapshot.paramMap.get('token');
    let parent = route.parent;
    while ((!lang || !token) && parent) {
      if (!lang) lang = parent.snapshot.paramMap && parent.snapshot.paramMap.get('lang');
      if (!token) token = parent.snapshot.paramMap && parent.snapshot.paramMap.get('token');
      parent = parent.parent;
    }
    // Use relative navigation array (no leading '/')
    const commands = [token,lang, section, ...subPaths].filter(Boolean);
    // Remove relativeTo if present (should be handled by caller if needed)
    if (extras && extras.relativeTo) {
      delete extras.relativeTo;
    }
    this.router.navigate(commands, extras);
  }
}
